// import react library
import Layout from './Layout';

export default Layout;
